/**
 * Transform selected products from cart state to ancillaries format for API
 * Converts cart structure to incoming_ancillaries and outgoing_ancillaries arrays
 *
 * @param {Object} selectedProducts - Selected products from cart state, keyed by passengerIndex
 * @returns {Object} Object keyed by passengerIndex with incoming/outgoing ancillaries
 *
 * @example
 * Input:
 *   selectedProducts = { 0: { outgoing: [{code: 'P1', quantity: 2}], incoming: [{code: 'BEB001', quantity: 1}] } }
 * Output:
 *   { 0: { outgoing_ancillaries: [{code: 'P1', quantity: 2, taxes: 0, meta: {}}], incoming_ancillaries: [...] } }
 */
function transformProductsToAncillaries(selectedProducts) {
  const result = {};

  Object.keys(selectedProducts).forEach((passengerIndex) => {
    const passengerProducts = selectedProducts[passengerIndex];

    result[passengerIndex] = {
      outgoing_ancillaries: (passengerProducts.outgoing || []).map((product) => ({
        code: product.code,
        quantity: product.quantity,
        taxes: 0,
        meta: {},
      })),
      incoming_ancillaries: (passengerProducts.incoming || []).map((product) => ({
        code: product.code,
        quantity: product.quantity,
        taxes: 0,
        meta: {},
      })),
    };
  });

  return result;
}

export default transformProductsToAncillaries;
